import { UserActionTypes } from 'actions/user';
import createReducer from 'utils/create-reducer';

export type UserState = {
  userName: string | null;
};

export const initialUserState: UserState = {
  userName: null,
};

const handlers = {
  [UserActionTypes.SET_USER_NAME]: (state: UserState, payload: string): UserState => ({
    ...state,
    userName: payload,
  }),
  // Leaving this handler for future use if we need to reset the user state on logout
  [UserActionTypes.RESET_USER]: (): UserState => initialUserState,
};

export const userReducer = createReducer<UserState>(handlers);
